export default __webpack_public_path__ + "images/468f639ca8c456bd4d29920d5cc5e284.png";